import { X } from 'lucide-react';
import type { BannerConfig } from '../types';

interface AnnouncementBannerProps {
  config: BannerConfig | null;
  onDismiss: () => void;
}

/**
 * Banner de anúncio configurável pelo admin.
 * Cores e texto vêm do backend; o dismiss é local (resetado ao atualizar a página).
 */
export function AnnouncementBanner({ config, onDismiss }: AnnouncementBannerProps) {
  if (!config || !config.active || !config.text) return null;

  return (
    <div
      role="region"
      aria-label="Aviso importante"
      style={{ backgroundColor: config.bgColor, color: config.textColor }}
      className="relative w-full px-10 py-2.5 text-center text-sm font-medium"
    >
      <span>{config.text}</span>
      <button
        onClick={onDismiss}
        aria-label="Fechar aviso"
        style={{ color: config.textColor }}
        className="absolute right-3 top-1/2 -translate-y-1/2 opacity-70 hover:opacity-100 transition-opacity p-1 rounded"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
